import { useIntl, type IntlShape } from 'react-intl'
import cruiseGlossaryMessages from 'hooks/Cruise/cruiseGlossaryMessages'

export function formatCruiseCabinTypeLabel(intl: IntlShape, cabinType: string): string {
  switch (cabinType.toLowerCase()) {
    case 'inside':
      return intl.formatMessage(cruiseGlossaryMessages.cabinInside)
    case 'oceanview':
      return intl.formatMessage(cruiseGlossaryMessages.cabinOceanview)
    case 'window':
      return intl.formatMessage(cruiseGlossaryMessages.cabinWindow)
    case 'oceanview_window':
      return intl.formatMessage(cruiseGlossaryMessages.oceanviewOrWindow)
    case 'balcony':
      return intl.formatMessage(cruiseGlossaryMessages.cabinBalcony)
    case 'suite':
      return intl.formatMessage(cruiseGlossaryMessages.cabinSuite)
    default:
      return cabinType
  }
}

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    inside: formatCruiseCabinTypeLabel(intl, 'inside'),
    oceanview: formatCruiseCabinTypeLabel(intl, 'oceanview'),
    window: formatCruiseCabinTypeLabel(intl, 'window'),
    oceanview_window: formatCruiseCabinTypeLabel(intl, 'oceanview_window'),
    balcony: formatCruiseCabinTypeLabel(intl, 'balcony'),
    suite: formatCruiseCabinTypeLabel(intl, 'suite'),
  }
}

export default useCruiseCabinTypeLabels
